// @flow

import { RECEIVED_BUSINESS_LABEL_SETTINGS } from './constants';
import type { BusinessLabelSettings } from './types';
import { receivedSocialLabelSettings } from '../socialSettings/actions';
import { receivedContactLabelSettings } from '../contactSettings/actions';
import { getEntries } from '../../helpers';

export type ReceivedBusinessLabelSettings = {|
  type: typeof RECEIVED_BUSINESS_LABEL_SETTINGS,
  payload: BusinessLabelSettings,
|};

export const receivedBusinessLabelSettings = (data: BusinessLabelSettings) => (
  (dispatch: Function) => {
    getEntries(data).forEach(([label, settings]) => {
      const { twitter, facebook, instagram } = settings;
      dispatch(receivedSocialLabelSettings(
        label, {
          twitter,
          facebook,
          instagram,
        },
      ));

      const { telephone, email, address } = settings;
      dispatch(receivedContactLabelSettings(
        label, {
          telephone,
          email,
          address,
        },
      ));
    });

    dispatch({
      type: RECEIVED_BUSINESS_LABEL_SETTINGS,
      payload: data,
    });
  }
);
